module.exports = __webpack_public_path__ + "static/media/nft-41.f12529fe.jpg";